// removed by extract-text-webpack-plugin
module.exports = {"container":"_3zuzTWZ","container__isIn":"siJXd1v","heading":"_7mMnkyq","body":"_3kmOQHR","actions":"B9-V2DF"};


//////////////////
// WEBPACK FOOTER
// ./template/components/GDPR/Confirmation/Confirmation.css
// module id = ./template/components/GDPR/Confirmation/Confirmation.css
// module chunks = client.sitechrome